module.exports = __webpack_public_path__ + "static/media/seasons-02.e9551706.png";